export const ERROR_LEVEL = 'error';
export const FATAL_LEVEL = 'fatal';
export const INFO_LEVEL = 'info';
